import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import { useGetUsersUserIdTestingActivitiesSuspense } from "api/generated/users/users";

export function useTestingActivitiesForUserQuery(userId: number) {
    return useGetUsersUserIdTestingActivitiesSuspense(userId, {
        query: {
            select: (response) => response.data,
            refetchOnMount: true,
            refetchOnWindowFocus: true,
            staleTime: STALE_TIME_RESOURCES,
        },
    });
}
